import { Pipe, PipeTransform } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { defaultLanguage } from '../../app.default.language';

@Pipe({
  name: 'translateLanguage',
})

export class translateLanguagePipe implements PipeTransform {

  constructor(public translate: TranslateService) { }

  transform(key: any): string {
    if (!key) {
      return '';
    }
  
    const map = this.translate.store.translations[this.translate.currentLang];
    // const word = map[key] || key;
    //   return word;
  
    if (!map) {
      return key;
    }
  
    // รองรับ flat key เช่น "TRANSLATE.th"
    if (map.hasOwnProperty(key)) {
      const flatValue = map[key];
      if (typeof flatValue === 'string') {
        return flatValue;
      }
    }
  
    // ถ้าไม่เจอ flat key ลองค้นหาแบบ nested key
    const keys = key.split('.');
    let word: any = map;
  
    for (const k of keys) {
      if (word && word.hasOwnProperty(k)) {
        word = word[k];
      } else {
        return key; // ไม่พบ key ระหว่างทาง
      }
    }
  
    return typeof word === 'string' ? word : key;
  }
  // transform(th: any, en: any) {
  //   return this.transalte.currentLang === 'th' ? th : en;
  // }
}

@Pipe({
  name: 'customTranslate',
})

export class CustomTranslatePipe extends TranslatePipe implements PipeTransform {

  transform(query: string, ...args: any[]): any {
    const modifiedQuery = query;
    const result = super.transform(modifiedQuery, args);

    return result !== modifiedQuery ? result : defaultLanguage[result] ? defaultLanguage[result] : result;
  }
}
